import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { LearnedPresetKind } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";

export const UsedWeightLearningCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Used weight learning",
    cell: (group) =>
      group.usedLearning?.[LearnedPresetKind.WEIGHT] ? "Yes" : "No",
  };
